import type { Mission } from '../types/database';

export const missionsData: Mission[] = [
  {
    id: 'mission-1-1',
    nom: 'Les daltonismes : La protanopie',
    numeroMission: 1,
    starting:'Bienvenue',
    description: 'Dans ce premier parcours je te propose de découvrir les problèmes que peuvent rencontrer les personnes qui, comme moi, voient les couleurs d\'une manière différente des autres.',
    audiodescription: 'Découverte des troubles de la perception des couleurs avec Mark Z.',
    mission:'ajoute à ton panier un t-shirt rouge.',
    mascotteId: 'mark-z',
    solutionId: 'solution-mission-1-1',
    parcoursId: 'parcours-1',
    codeMission: 'parcours-1/mission-1',
    fiche:{
      barriere:[
        "Information transmise uniquement par la couleur",
        "Couleurs très similaires en vision daltonienne",
        "Absence d'alternatives textuelles pour les codes couleur"
      ],
      solutions:[
        "Utiliser des textes en plus des couleurs",
        "Tester avec des simulateurs de daltonisme",
        "Proposer des thèmes à forts contrastes"
      ]
    }
  },
  {
    id: 'mission-1-2',
    nom: 'Les daltonismes : L’achromatopsie',
    numeroMission: 2,
    starting:'',
    description: 'Pour continuer, je te propose de découvrir les problèmes que peuvent rencontrer les personnes achromates, qui comme-moi, voient la vie uniquement en niveaux de gris.',
    audiodescription: 'x',
    mission:'sélectionne toutes les formes rouges.',
    mascotteId: 'sandrine-m',
    solutionId: 'solution-mission-1-2',
    parcoursId: 'parcours-1',
    codeMission: 'parcours-1/mission-2',
    fiche:{
      barriere:[
        "Information transmise uniquement par la couleur"
      ],
      solutions:[
        "Utiliser un texte, un motif ou une forme en plus des couleurs",
        "Tester avec des simulateurs de daltonisme",
        "Proposer des thèmes à forts contrastes"
      ]
    }
  },
  {
    id: 'mission-2-1',
    nom: 'La cataracte : Vision Floue',
    numeroMission: 1,
    starting:'Bienvenue',
    description: 'Dans ce parcours je te propose de découvrir les problèmes que peuvent rencontrer les personnes qui, comme-moi, voient flou.',
    audiodescription: 'x',
    mission:'lis le texte et répond à la question.',
    mascotteId: 'claude-m',
    solutionId: 'solution-mission-2-1',
    parcoursId: 'parcours-2',
    codeMission: 'parcours-2/mission-1',
    fiche:{
      barriere:[
        "Texte trop petit",
        "Manque de contraste entre le texte et son arrière plan"
      ],
      solutions:[
        "Utiliser des polices lisibles, de taille adaptée et éviter les styles trop fins",
        "Proposer des options de personnalisation (mode contrasté, zoom, thèmes alternatifs)",
        "Permettre à l’utilisateur de zoomer la page ou d’agrandir le texte sans perte d’information"
      ]
    }
  },
  {
    id: 'mission-2-2',
    nom: 'La cataracte : diminution des contrastes',
    numeroMission: 2,
    starting:'',
    description: 'Certaines personnes ayant un trouble de la vision, ont du mal à distinguer les choses peu contrastés. Elles peuvent aussi avoir des difficultés de mise au point lors des changement de distance ou de luminosité.',
    audiodescription: 'x',
    mission:'lis le texte et répond à la question.',
    mascotteId: 'claude-m',
    solutionId: 'solution-mission-2-2',
    parcoursId: 'parcours-2',
    codeMission: 'parcours-2/mission-2',
    fiche:{
      barriere:[
        "Manque de contraste entre le texte et son arrière plan",
        "Combinaison de couleurs provoquant un effet de flou (vibration visuelle), rendant le texte illisible "
      ],
      solutions:[
        "Vérifier les ratios de contrastes avec des outils comme Contrast Checker",
        "Assurer des contrastes d’au moins 4,5:1 pour du texte normal et 3:1 pour du texte large",
        "Éviter les combinaisons qui vibrent (deux couleurs saturées et proches en luminosité)"
      ]
    }
  },

  {
    id: 'mission-3-1',
    nom: 'Naviguer avec des tremblements',
    numeroMission: 1,
    starting:'Bienvenue',
    description: 'Dans ce parcours je te propose de découvrir les problèmes que peuvent rencontrer les personnes qui, comme-moi, manquent de précision dans leurs gestes.',
    audiodescription: 'x',
    mission:'clique sur le bouton “ici”.',
    mascotteId: 'ozzy-o-moteurs',
    solutionId: 'solution-mission-3-1',
    parcoursId: 'parcours-3',
    codeMission: 'parcours-3/mission-1',
    fiche:{
      barriere:[
        "Bouton de petite taille",
        "Pas d’alternative à l’utilisation de la souri"
      ],
      solutions:[
        "Éviter les actions qui demandent de la précision ou de la rapidité et les actions déclenchées par des mouvements",
        "Respecter une taille minimale d’interaction de 44 x 44px",
        "Créer une zone cliquable transparente (zone de sécurité) autour des éléments plus petits",
        "Bien espacer les zones d’interaction les unes des autres",
        "Permettre la navigation au clavier"
      ]
    }
  },

  {
    id: 'mission-4-1',
    nom: 'Retenir une information dans un processus en plusieurs étapes',
    numeroMission: 1,
    starting:'À nous deux',
    description: 'Dans ce parcours je te propose de découvrir une problématique parfois rencontrée par les personnes qui, comme-moi, ont un trouble de l’attention ou de la mémoire.',
    audiodescription: 'x',
    mission:'retenir une suite de 6 chiffres. Facile ? On va voir ça !',
    mascotteId: 'channing-t',
    solutionId: 'solution-mission-4-1',
    parcoursId: 'parcours-4',
    codeMission: 'parcours-4/mission-1',
    fiche:{
      barriere:[
        "Code à 6 chiffres à retenir",
        "Nombreuses distractions avant la restitution du code",
        "Délai de réponse très court"
      ],
      solutions:[
        "Supprimer les étapes intermédiaires et limiter les distractions inutiles (animations purement esthétiques)",
        "Permettre de mettre en pause le chronomètre ou le supprimer",
        "Dans le cas d’un code pour un CAPCHA, proposer des alternatives"
      ]
    }
  },

  {
    id: 'mission-5-1',
    nom: 'La dyslexie',
    numeroMission: 1,
    starting:'Salut',
    description: 'Maintenant tu vas découvrir les difficultés que peuvent rencontrer les personnes ayant des troubles DYS pour écrire et comprendre du contenu.',
    audiodescription: 'x',
    mission:'déchiffre le texte puis répond à la question dans les temps !',
    mascotteId: 'orlando-b-cognitifs',
    solutionId: 'solution-mission-5-1',
    parcoursId: 'parcours-5',
    codeMission: 'parcours-5/mission-1',
    fiche:{
      barriere:[
        "Tout le texte est en gras",
        "Limite de temps pour répondre à la question",
        "Texte centré"
      ],
      solutions:[
        "Ne pas imposer de limite de temps",
        "Aligner le texte à gauche",
        "Proposer des solutions d’aide à la lecture (règle, division syllabique, coloration des lignes...)",
        "Permettre de modifier la police d’écriture (Comic Sans MS, Open Dyslexique...)"
      ]
    }
  },
];